//Image Mapping Module on Product Pages

(function($){
    if ( $('.image-mapping').length > 0 ) {
        $('.image-mapping .interest-point:first-of-type').addClass('active');
        $('.image-mapping .interest-point').click(function(e) {
            e.preventDefault();
            var hotspotHREF = $(this).attr('href');
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
            $(this).parents('.tech-image').siblings('.tech-content').children('.info-container').children(hotspotHREF).addClass('active');
            $(this).parents('.tech-image').siblings('.tech-content').children('.info-container').children(hotspotHREF).siblings().removeClass('active');
            $(this).parents('.tech-image').siblings('.tech-content').children('.info-container').children(hotspotHREF).children('.additional-content').slideToggle();
            $(this).parents('.tech-image').siblings('.tech-content').children('.info-container').children(hotspotHREF).siblings().children('.additional-content').slideUp();
        });
        $('.image-mapping .info-row:first-of-type').addClass('active');
        $('.image-mapping .info-row:first-of-type .additional-content').slideToggle();
        $('.image-mapping .info-row a').click(function(f) {
            f.preventDefault();
            var hotspotHREF = $(this).attr('href');
            $(this).parents('.image-mapping .info-row').toggleClass('active');
            $(this).siblings('.additional-content').slideToggle();
            $(this).parents('.info-row').siblings().children('.additional-content').slideUp();
            $(this).parents('.info-row').siblings().removeClass('active');
            $(this).parents('.info-row').addClass('active');
            $(this).siblings('.additional-content').removeClass('active');
            $(this).parents('.tech-content').siblings('.tech-image').children('.image-container').children(hotspotHREF).addClass('active');
            $(this).parents('.tech-content').siblings('.tech-image').children('.image-container').children(hotspotHREF).siblings().removeClass('active');
        });
    }
})(jQuery);
